import React from "react";
import { type Components } from "react-markdown";

export const customRenderers: Partial<Components> = {
  a: ({ children, href, title }) => (
    <a href={href} className="text-brand-gold-600 underline" title={title}>
      {children}
    </a>
  ),
  p: ({ children }) => <p className="mb-2 whitespace-pre-wrap">{children}</p>,
  h1: ({ children }) => <h1 className="mb-4 mt-6 whitespace-pre-wrap text-2xl font-bold">{children}</h1>,
  h2: ({ children }) => <h2 className="mb-3 mt-5 whitespace-pre-wrap text-xl font-bold">{children}</h2>,
  h3: ({ children }) => <h3 className="mb-2 mt-4 whitespace-pre-wrap text-lg font-bold">{children}</h3>,
  strong: ({ children }) => {
    const isFullLine = typeof children === "string" && !children.includes(" ");
    return isFullLine ? (
      <h4 className="my-4 whitespace-pre-wrap font-bold">{children}</h4>
    ) : (
      <strong className="my-2 whitespace-pre-wrap font-semibold">{children}</strong>
    );
  },
  em: ({ children }) => <em className="whitespace-pre-wrap italic">{children}</em>,
  code: ({
    className,
    children,
    ...props
  }: React.ClassAttributes<HTMLElement> & React.HTMLAttributes<HTMLElement> & { inline?: boolean }) => {
    const match = /language-(\w+)/.exec(className || "");
    const inline = props.inline;
    return !inline && match ? (
      <pre className="my-4 whitespace-pre-wrap rounded p-2">
        <code className={className} {...props}>
          {children}
        </code>
      </pre>
    ) : (
      <code className="whitespace-pre-wrap rounded px-1" {...props}>
        {children}
      </code>
    );
  },
  ul: ({ children }) => <ul className="my-4 list-none space-y-2 pl-6">{children}</ul>, // Added padding for alphabetic lists and bullet lists
  ol: ({ children }) => <ol className="my-4 list-decimal space-y-2 pl-6">{children}</ol>, // Added padding for numeric lists
  li: ({ children }) => (
    <li className="relative pl-5">
      <span className="mr-2">&bull;</span>
      <span>{children}</span>
    </li>
  ),
  blockquote: ({ children }) => (
    <blockquote className="my-4 whitespace-pre-wrap border-l-4 border-gray-300 pl-4 italic">{children}</blockquote>
  ),
};
